var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditProfileBtnIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "EditProfile_24PX",
    transform: "translate(-1071 -647)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1221",
    "data-name": "Rectangle 1221",
    width: 24,
    height: 24,
    transform: "translate(1071 647)",
    fill: "#fcd29d",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3300",
    "data-name": "Group 3300"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1222",
    "data-name": "Rectangle 1222",
    width: 22,
    height: 22,
    transform: "translate(1072 648)",
    fill: "#ffecd4",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3299",
    "data-name": "Group 3299",
    transform: "translate(-1 -1.042)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_204",
    "data-name": "Ellipse 204",
    cx: 0.57,
    cy: 0.57,
    r: 0.57,
    transform: "translate(1077.02 663.06)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1177",
    d: "M14.45,6.85c-.18,2.41-1.98,4.37-3.97,4.37S6.68,9.26,6.51,6.85a3.986,3.986,0,1,1,7.94-.71,4.208,4.208,0,0,1,0,.71h0Z",
    transform: "translate(1072.08 648.06)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.49
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1178",
    d: "M4.09,16.41a6.966,6.966,0,0,0-2.26,4.03.776.776,0,0,0,.52.95.566.566,0,0,0,.18.03H8.34",
    transform: "translate(1072.08 648.06)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1.49
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1178-2",
    d: "M12.34,14.29a10.71,10.71,0,0,0-5.35.43",
    transform: "translate(1072.08 648.06)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1.49
  }), /*#__PURE__*/React.createElement("g", {
    id: "edit-3",
    transform: "translate(1072.08 648.06)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1179",
    d: "M16.18,21.48h5.99",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.49
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1180",
    d: "M19.18,10.4a1.41,1.41,0,0,1,2-.04,1.443,1.443,0,0,1,.04,2.02c-.01.01-.02.03-.04.04l-8.33,8.4-2.66.67.67-2.69,8.33-8.4Z",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.49
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditProfileBtnIcon);
export default __webpack_public_path__ + "static/media/edit-profile-btn-icon.27e1bdd820f830a6a3b7690dc64cb8f9.svg";
export { ForwardRef as ReactComponent };